import { FlightStats } from '../model/flight_stats';
export class FlightStatsBuilder {
    static buildFlightStats(data) {
        let flightStats = new FlightStats();
        flightStats.id = data.id;
        flightStats.id_reservation = data.id_reservation;
        flightStats.flight_id = data.flight_id;
        flightStats.status = data.status;
        flightStats.last_checked = data.last_checked ? new Date(data.last_checked) : null;
        flightStats.fs_status = data.fs_status;
        flightStats.fs_published_arrival = data.fs_publishedArrival ? new Date(data.fs_publishedArrival) : null;
        flightStats.fs_scheduled_gate_arrival = data.fs_scheduledGateArrival ? new Date(data.fs_scheduledGateArrival) : null;
        flightStats.fs_estimated_gate_arrival = data.fs_estimatedGateArrival ? new Date(data.fs_estimatedGateArrival) : null;
        flightStats.fs_actual_gate_arrival = data.fs_actualGateArrival ? new Date(data.fs_actualGateArrival) : null;
        flightStats.fs_flight_plan_planned_arrival = data.fs_flightPlanPlannedArrival ? new Date(data.fs_flightPlanPlannedArrival) : null;
        flightStats.fs_scheduled_runway_arrival = data.fs_scheduledRunwayArrival ? new Date(data.fs_scheduledRunwayArrival) : null;
        flightStats.fs_estimated_runway_arrival = data.fs_estimatedRunwayArrival ? new Date(data.fs_estimatedRunwayArrival) : null;
        flightStats.fs_actual_runway_arrival = data.fs_actualRunwayArrival ? new Date(data.fs_actualRunwayArrival) : null;
        flightStats.fs_departure_gate_delay_minutes = data.fs_departureGateDelayMinutes;
        flightStats.fs_departure_runway_delay_minutes = data.fs_departureRunwayDelayMinutes;
        flightStats.fs_arrival_gate_delay_minutes = data.fs_arrivalGateDelayMinutes;
        flightStats.fs_arrival_runway_delay_minutes = data.fs_arrivalRunwayDelayMinutes;
        flightStats.fs_updated_at = data.fs_updatedAt ? new Date(data.fs_updatedAt) : null;
        flightStats.arrival_terminal = data.arrival_terminal ? data.arrival_terminal : null;
        return flightStats;
    }
}
//# sourceMappingURL=flight-stats-builder.js.map